// import React, { Component } from 'react';
// import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { listUsers } from '../actions/user';
import { SelectPicker } from 'rsuite';
import UserAdd from './UserAdd';



class Users extends React.Component {
  constructor() {
      super();
      this.state = {
        currentSort : 'name',
        name: '',
        errors: {},
        list: []
      };
      this.handleSortSelect = this.handleSortSelect.bind(this);
      this.fetchApi = this.fetchApi.bind(this);
  }

  fetchApi() {
    let currentorg = localStorage.getItem('currentorg');
    this.props.listUsers('dada', currentorg, this.props.history);
  }

  componentDidMount() {
    let currentSort = localStorage.getItem('userslistsort');
    if (currentSort){
        this.setState({currentSort: currentSort});
    }

    this.fetchApi();
    this.timeout = setInterval(() => {
      this.fetchApi();
    }, 10000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleSortSelect(e) {
    console.log('e',e);
    let currentorg = localStorage.getItem('currentorg');
    let l = this.props.users.list;
    let s = l.sort((a, b) => a.name.localeCompare(b.name));
    this.props.listUsers(e, currentorg, this.props.history);
    this.setState({currentSort: e});

    localStorage.setItem('userslistsort', e);
  }

    render() {
      // const { errors } = this.state;
      // console.log(this.props.users.list);
        return (
          <div className="wrapper users">
            <div className="component-header">
              <div className="left">
                {this.state.currentSort}
                <SelectPicker
                  data={[{ label: 'Nazwa', value: 'name' },{ label: 'Email', value: 'email' }]}
                  searchable={false}
                  defaultValue={'name'}
                  cleanable={false}
                  onChange={this.handleSortSelect}
                />
              </div>
              <div className="right">
                <UserAdd />
              </div>
            </div>
            <ul className="list">
            {
// this.props.users.list.sort((a, b) => a.name.localeCompare(b.name))



              this.props.users.list.map((user, i) => (
                <li key={user._id} className="user">
                  <div className="left">
                    <div className="top-line">
                      <div className="user_name">{user.name}</div>
                      <div className="user_email">{user.email}</div>
                    </div>
                  </div>
                  <div className="details">
                    <div className="right">
                      Szczegóły
                    </div>
                  </div>
                </li>
              ))
            }
            </ul>
          </div>
        );
    }
}

Users.propTypes = {
    listUsers: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    users: state.users,
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps,{ listUsers })(withRouter(Users))
